var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    {
      attrs: {
        "app-name": "settings",
        "navigation-class": { "icon-loading": _vm.loadingAddGroup }
      }
    },
    [
      _c(
        "AppNavigation",
        [
          _c("AppNavigationNew", {
            attrs: {
              "button-id": "new-user-button",
              text: _vm.t("settings", "New user"),
              "button-class": "icon-add"
            },
            on: { click: _vm.toggleNewUserMenu }
          }),
          _vm._v(" "),
          _c(
            "ul",
            { attrs: { id: "usergrouplist" } },
            [
              _c("AppNavigationItem", {
                ref: "addGroup",
                attrs: {
                  id: "addgroup",
                  "edit-placeholder": _vm.t("settings", "Enter group name"),
                  editable: true,
                  loading: _vm.loadingAddGroup,
                  title: _vm.t("settings", "Add group"),
                  icon: "icon-add"
                },
                on: {
                  click: function($event) {
                    return _vm.toggleAddGroupEntry(true)
                  },
                  "update:title": _vm.createGroup
                }
              }),
              _vm._v(" "),
              _c(
                "AppNavigationItem",
                {
                  attrs: {
                    id: "everyone",
                    exact: true,
                    title: _vm.t("settings", "Everyone"),
                    to: { name: "users" },
                    icon: "icon-contacts-dark"
                  }
                },
                [
                  _vm.userCount > 0
                    ? _c(
                        "AppNavigationCounter",
                        { attrs: { slot: "counter" }, slot: "counter" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.userCount) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.settings.isAdmin
                ? _c(
                    "AppNavigationItem",
                    {
                      attrs: {
                        id: "admin",
                        exact: true,
                        title: _vm.t("settings", "Admins"),
                        to: {
                          name: "group",
                          params: { selectedGroup: "admin" }
                        },
                        icon: "icon-user-admin"
                      }
                    },
                    [
                      _vm.adminGroupMenu.count
                        ? _c(
                            "AppNavigationCounter",
                            { attrs: { slot: "counter" }, slot: "counter" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.adminGroupMenu.count) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.disabledGroupMenu.usercount > 0 ||
              _vm.disabledGroupMenu.usercount === -1
                ? _c(
                    "AppNavigationItem",
                    {
                      attrs: {
                        id: "disabled",
                        exact: true,
                        title: _vm.t("settings", "Disabled users"),
                        to: {
                          name: "group",
                          params: { selectedGroup: "disabled" }
                        },
                        icon: "icon-disabled-users"
                      }
                    },
                    [
                      _vm.disabledGroupMenu.usercount > 0
                        ? _c(
                            "AppNavigationCounter",
                            { attrs: { slot: "counter" }, slot: "counter" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.disabledGroupMenu.usercount) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.groupList.length > 0
                ? _c("AppNavigationCaption", {
                    attrs: { title: _vm.t("settings", "Groups") }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.groupList, function(group) {
                return _c(
                  "AppNavigationItem",
                  {
                    key: group.id,
                    attrs: {
                      exact: true,
                      title: group.title,
                      to: {
                        name: "group",
                        params: { selectedGroup: encodeURIComponent(group.id) }
                      }
                    }
                  },
                  [
                    group.count
                      ? _c(
                          "AppNavigationCounter",
                          { attrs: { slot: "counter" }, slot: "counter" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(group.count) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "template",
                      { slot: "actions" },
                      [
                        group.id !== "admin" &&
                        group.id !== "disabled" &&
                        _vm.settings.isAdmin
                          ? _c(
                              "ActionButton",
                              {
                                attrs: { icon: "icon-delete" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeGroup(group.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(_vm.t("settings", "Remove group")) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("AppNavigationSettings", [
            _c(
              "div",
              [
                _c("p", [_vm._v(_vm._s(_vm.t("settings", "Default quota:")))]),
                _vm._v(" "),
                _c("Multiselect", {
                  attrs: {
                    value: _vm.defaultQuota,
                    options: _vm.quotaOptions,
                    "tag-placeholder": "create",
                    placeholder: _vm.t("settings", "Select default quota"),
                    label: "label",
                    "track-by": "id",
                    "allow-empty": false,
                    taggable: true
                  },
                  on: { tag: _vm.validateQuota, input: _vm.setDefaultQuota }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showLanguages,
                    expression: "showLanguages"
                  }
                ],
                staticClass: "checkbox",
                attrs: { id: "showLanguages", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showLanguages)
                    ? _vm._i(_vm.showLanguages, null) > -1
                    : _vm.showLanguages
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.showLanguages,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showLanguages = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showLanguages = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showLanguages = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "showLanguages" } }, [
                _vm._v(_vm._s(_vm.t("settings", "Show Languages")))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showLastLogin,
                    expression: "showLastLogin"
                  }
                ],
                staticClass: "checkbox",
                attrs: { id: "showLastLogin", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showLastLogin)
                    ? _vm._i(_vm.showLastLogin, null) > -1
                    : _vm.showLastLogin
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.showLastLogin,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showLastLogin = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showLastLogin = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showLastLogin = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "showLastLogin" } }, [
                _vm._v(_vm._s(_vm.t("settings", "Show last login")))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showUserBackend,
                    expression: "showUserBackend"
                  }
                ],
                staticClass: "checkbox",
                attrs: { id: "showUserBackend", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showUserBackend)
                    ? _vm._i(_vm.showUserBackend, null) > -1
                    : _vm.showUserBackend
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.showUserBackend,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showUserBackend = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showUserBackend = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showUserBackend = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "showUserBackend" } }, [
                _vm._v(_vm._s(_vm.t("settings", "Show user backend")))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showStoragePath,
                    expression: "showStoragePath"
                  }
                ],
                staticClass: "checkbox",
                attrs: { id: "showStoragePath", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showStoragePath)
                    ? _vm._i(_vm.showStoragePath, null) > -1
                    : _vm.showStoragePath
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.showStoragePath,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showStoragePath = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showStoragePath = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showStoragePath = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "showStoragePath" } }, [
                _vm._v(_vm._s(_vm.t("settings", "Show storage path")))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sendWelcomeMail,
                    expression: "sendWelcomeMail"
                  }
                ],
                staticClass: "checkbox",
                attrs: {
                  id: "sendWelcomeMail",
                  disabled: _vm.loadingSendMail,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.sendWelcomeMail)
                    ? _vm._i(_vm.sendWelcomeMail, null) > -1
                    : _vm.sendWelcomeMail
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.sendWelcomeMail,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.sendWelcomeMail = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.sendWelcomeMail = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.sendWelcomeMail = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "sendWelcomeMail" } }, [
                _vm._v(_vm._s(_vm.t("settings", "Send email to new user")))
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "AppContent",
        [
          _c("UserList", {
            attrs: {
              users: _vm.users,
              "show-config": _vm.showConfig,
              "selected-group": _vm.selectedGroupDecoded,
              "external-actions": _vm.externalActions
            },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function() {
                  return undefined
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }